import React, { Component } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import countryCurrencies from '$constants/country-currencies-map.json';

export default class GetCountry extends Component{
  
  constructor(props) {
    super(props);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(::this.getLocation, ::this.fallBack);
    } else {
      fallBack();
    }
  }

  static get countryCode() {
    return Cookies.get('COUNTRY_CODE');
  }

  static get currencyCode() {
    return countryCurrencies[this.countryCode || 'TR'];
  }

  getLocation(position) {
    const geocoder = new google.maps.Geocoder();
    const latlong = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

    geocoder.geocode({ 'latLng': latlong }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          for (let i = 0; i < results[0].address_components.length; i++) {
            const shortname = results[0].address_components[i].short_name;
            const type = results[0].address_components[i].types;
            if (type.includes("country")) {
              Cookies.set('COUNTRY_CODE', shortname);
            }
          }
        }
      }
    });
  }

  fallBack() {
    axios.get('https://ipinfo.io').then( (response) => {
      Cookies.set('COUNTRY_CODE', response.data.country);
    });
  }

}



// WEBPACK FOOTER //
// ./src/lib/get-country.js